<template>
    <v-dialog v-model="model" width="700">
        <div class="container">

            <div class="animation-container">

                <v-fade-transition>

                    <div class="animation-item" v-show="!showParsed">

                        <v-alert type="info" prominent class="body-2" dense>
                            Paste question and options into the box below
                        </v-alert>

                        <v-textarea hide-details
                                    autofocus
                                    v-model="pasteAreaModel"
                                    style="width: 660px"
                                    solo
                                    placeholder="Paste options into this box"
                                    rows="16"
                                    spellcheck="false"
                                    @input="pasted"
                                    background-color="grey darken-3"
                                    class="monospace body-2"/>
                    </div>

                </v-fade-transition>

                <v-fade-transition>
                    <div class="animation-item" v-show="showParsed">

                        <div class="d-flex mb-3">
                            <v-btn color="primary" class="align-self-center" v-show="showParsed" @click="accepted">
                                Looks good?
                            </v-btn>

                            <v-btn text class="align-self-center" v-show="showParsed" @click="resetClicked">
                                Restart
                            </v-btn>

                            <div class="flex-grow-1"></div>

                            <v-tooltip top color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon class="ml-4" dark @click="closeClicked">
                                        <v-icon> mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Close</span>
                            </v-tooltip>

                        </div>

                        <v-data-table
                            style="width: 660px;"
                            :items="options"
                            hide-default-footer
                            hide-default-header
                            disable-pagination
                            dense
                        >
                            <template v-slot:body="{ items }">
                                <tbody>
                                <tr v-for="(item, index) in items" :key="item.option_id">
                                    <td class="text-left pl-0">
                                        <div class="d-flex pt-2 pb-2">
                                            <v-chip label class="ml-2 mr-0">{{ index + 1 }}</v-chip>

                                            <v-tooltip top max-width="300" open-delay="500" color="primary">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-on="on"
                                                        dense
                                                        color="primary"
                                                        rounded
                                                        background-color="transparent"
                                                        hide-details
                                                        class="elevation-0 flex-grow-1 mr-2 mb-1"
                                                        v-model="item.model"
                                                    />
                                                </template>
                                                Click here to edit
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </template>

                        </v-data-table>

                    </div>
                </v-fade-transition>

            </div>
        </div>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';
import ToolbarPage from "../../../components/UI/ToolbarPage";

const vuexModule = 'VuexStore';

export default {

    components: {
        ToolbarPage,
        Json
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        minOptions: {
            required: false,
            type: Number | null,
            default: null,
        },
        maxOptions: {
            required: false,
            type: Number | null,
            default: null,
        },
        name: {
            required: true,
            type: String,
            validator: (value) => ['data variable','question'].includes(value)
        }
    },

    computed: {
        ...mapState(vuexModule, []),

        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },

    data() {
        return {
            pasteAreaModel: null,
            showParsed: false,
            options: [],
        }
    },

    methods: {

        closeClicked() {
            this.$emit('input', false);
            this.resetClicked();
        },

        accepted() {

            this.pasteAreaModel = null;

            this.$emit('change', this.options.map(option => option.name));

            this.options = [];
            this.showParsed = false;
            this.$emit('input', false);
        },

        resetClicked() {
            this.pasteAreaModel = null;
            this.showParsed = false;
        },

        pasted(data) {

            let optionNames = data
                .replaceAll('"', '')
                .replaceAll(/(\r\n|\n|\r)/gm, "\n")
                .split("\n")
                .filter(line => line.length > 0);

            this.pasteAreaModel = optionNames.join("\n");
            this.options = optionNames.map(name => {
                return {name: name, model: name}
            });

            this.showParsed = true;

            if (this.maxOptions && this.options.length > this.maxOptions) {
                Bus.$emit('flash-message', {
                    type: 'warning',
                    duration: 10000,
                    message: 'The ' + this.name + ' has ' + this.maxOptions + ' options but you pasted ' + this.options.length + ' option(s)!'
                })
            }

            if (this.minOptions && this.minOptions > this.options.length) {
                Bus.$emit('flash-message', {
                    type: 'warning',
                    duration: 10000,
                    message: 'The ' + this.name + ' has ' + this.minOptions + ' options but you only pasted ' + this.options.length + ' option(s)!'
                })
            }
        }
    }
}
</script>

<style scoped>

.container {
    background-color: #555555;
}

.animation-container {
    position: relative;
    min-height: 550px;
    width: 100%;
}

.animation-item {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
}
</style>